import { Component, DestroyRef, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CrmAssociationService } from '../../../shared-services/crm-services/crm-object-service/crm-association.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { GalaxyTagsModule } from '@vendasta/galaxy/tags';
import { catchError, debounceTime, map, Observable, of, switchMap, tap } from 'rxjs';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { DEFAULT_TAG_SEARCH_SIZE, RESERVED_TAGS, SEARCH_DEBOUNCE_MS } from '../../../constants';

@Component({
  selector: 'crm-edit-association-tags',
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    GalaxyTagsModule,
    ReactiveFormsModule,
    GalaxyFormFieldModule,
  ],
  templateUrl: './edit-association-tags.component.html',
  styleUrls: ['./edit-association-tags.component.scss'],
})
export class EditAssociationTagsComponent {
  @Input() set tags(tags: string[]) {
    this.tagsControl.setValue(tags);
  }
  @Input({ required: true }) associationType: string;
  @Output() tagsChanged = new EventEmitter<string[]>();

  tagsControl = new FormControl<string[]>([]);

  searchTextChanged = signal<string>('');
  filteredTags$ = toObservable(this.searchTextChanged).pipe(
    takeUntilDestroyed(this.destroyRef),
    debounceTime(SEARCH_DEBOUNCE_MS),
    switchMap((searchText) => this.listTags(searchText)),
    catchError(() => {
      return of([]);
    }),
    map((tags) => {
      return tags.filter((tag) => !RESERVED_TAGS.includes(tag?.toLowerCase()));
    }),
  );

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly crmAssociationService: CrmAssociationService,
  ) {
    this.tagsControl.valueChanges
      .pipe(
        takeUntilDestroyed(),
        tap((tags) => this.tagsChanged.emit(tags)),
      )
      .subscribe();
  }

  private listTags(value: string): Observable<string[]> {
    return this.crmAssociationService.listAssociationFieldOptions(
      this.associationType,
      'tags',
      DEFAULT_TAG_SEARCH_SIZE,
      value,
    );
  }
}
